/**
 * Default nearby pin detection radius in Web Mercator units.
 * This value is converted to game-coordinate space at runtime using the
 * game's scale factors (deltas), so it works universally across games.
 *
 * ~250 000 mercator units ≈ 25 game-units in Sons of the Forest, used to calibrate.
 */
export const DEFAULT_NEARBY_DISTANCE_MERCATOR = 250_000;
